import http from "@/utils/http";


export const DeviceRuleApi = {
	querySimpleList(){
		return http.get(`/nexus/acsDeviceTimeRule/querySimpleList` )
	},
	deviceRegulationPage(querForm) {
		return http.get("/nexus/acsDeviceTimeRule/page",querForm);
	},
	save(form) {
		return http.post("/nexus/acsDeviceTimeRule/save",form);
	},
	getById(id) {
		return http.get(`/nexus/acsDeviceTimeRule/query/${id}`);
	},
	
	getRuleNumber() {
		return http.get("/nexus/acsDeviceTimeRule/queryUndistributedRuleNumber");
	},

	deleteById(id) {
		return http.get(`/nexus/acsDeviceTimeRule/delete/${id}`);
	},

	notBindDeviceRegulationList(deviceRegulationId) {
		return http.get('/nexus/acsDeviceTimeRule/selectNotBindingDmsDeviceRespVoList', {
			timeRuleId: deviceRegulationId
		});
	},

	bindDeviceRegulationList(deviceRegulationId) {
		return http.get('/nexus/acsDeviceTimeRule/selectBindingDmsDeviceRespVoList', {
			timeRuleId: deviceRegulationId
		});
	},

	saveBindDeviceRegulation(deviceBindForm) {
		return http.post('/nexus/acsDeviceTimeRule/bindingDmsDevice',deviceBindForm);
	},
}


/*

export const deviceRegulationPage = (querForm) => {
	return http.get("/nexus/acsDeviceTimeRule/page",querForm);
};

export const save = (form) => {
	return http.post("/nexus/acsDeviceTimeRule/save",form);
};

export const getById = (id) => {
	return http.get(`/nexus/acsDeviceTimeRule/query/${id}`);
};

export const deleteById = (id) => {
	return http.get(`/nexus/acsDeviceTimeRule/delete/${id}`);
};

export const notBindDeviceRegulationList = (deviceRegulationId) => {
	return http.get('/nexus/acsDeviceTimeRule/selectNotBindingDmsDeviceRespVoList', {
		timeRuleId: deviceRegulationId
	});
}

export const bindDeviceRegulationList = (deviceRegulationId) => {
	return http.get('/nexus/acsDeviceTimeRule/selectBindingDmsDeviceRespVoList', {
		timeRuleId: deviceRegulationId
	});
}

export const saveBindDeviceRegulation = (deviceBindForm) => {
	return http.post('/nexus/acsDeviceTimeRule/bindingDmsDevice',deviceBindForm);
}*/
